import type { FaireProductEntity } from "../../entity_types/product";

export const p_pf56k3he6g: FaireProductEntity = {
  token: "p_pf56k3he6g",
  type: "product",
  name: "V-NECK SLEEVELESS TOP",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/196f7474acbd0c87f74f8275845394b939ba013005f1c9f5e20f96d3590341c8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c35947853fd5e7a0b57b23d20f255dac58b6d855ac95be9b26d6c255d945262d.jpeg",
    "https://cdn.faire.com/fastly/b25331459d63d9c9bb08f36c9ae93d04973939c66fea51dbdd3f3ffea9e7849f.jpeg",
    "https://cdn.faire.com/fastly/37be3961f04d96178f812413c020026434af70dbbf290d6a8fb41ba4ec39fac9.jpeg",
    "https://cdn.faire.com/fastly/bddfdd121cfd9bb0d932e7ea01a1ecab51e525d7e6887936617ded6c879ba844.jpeg",
    "https://cdn.faire.com/fastly/862c59581cf53deebe02869549fbe84318c6354dbe8428649d2c3761c85658e1.jpeg",
    "https://cdn.faire.com/fastly/3ae2e5499832a003de8e88477cc01fb85fb9bf8fb769903a54bb3093eb76f1d3.jpeg",
  ],
  priceDollars: 144,
  description:
    'MODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32B\nWAIST: 24"\nHIPS: 34"',
  tags: [],
  msrpDollars: 288,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:08.113Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
